import {
  Row,
  Col,
  Button,
  Form as BForm
} from '@themesberg/react-bootstrap'
import React from 'react'
import ClientFilter from '../../../components/ClientFilter'
import PortalFilter from '../../../components/PortalFilter'
import { tableHeaders } from './bonusConstant'
import useBonus from './hooks/useBonus'
import { bonusType } from './components/CreateBonus/constants'
import BonusListing from '../../../components/BonusListing'
import useCheckPermission from '../../../utils/checkPermission'
import { AdminsRoutes } from '../../../routes'
import { GiveBonus, GiveFreeSpins } from '../../../components/BonusIssue'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
import { motion } from 'framer-motion/dist/framer-motion'
import { Reorder } from '@mui/icons-material'

const BonusManagement = () => {
  const {
    selectedClient,
    selectedPortal,
    setSelectedPortal,
    setSelectedClient,
    bonusList,
    navigate,
    loading,
    handleShow,
    show,
    setShow,
    handleYes,
    active,
    limit,
    setLimit,
    setPage,
    page,
    totalPages,
    bonusTyp,
    setBonusTyp,
    search,
    setSearch,
    isActive,
    setIsActive,
    name,
    showGiveModal,
    setShowGiveModal,
    showDeleteModal,
    setShowDeleteModal,
    showFreeSpinModal,
    setShowFreeSpinModal,
  } = useBonus()
  const { isHidden } = useCheckPermission()
  return (
    <>

    <div className='section-header-wrap mt-n3 mx-n3'>
      <Row>
        <Col lg={4} xs={12}>
            <h2 className='title-text'>Bonus </h2>
          </Col>
          <Col xs={12} sm={8}>
          <div className='d-flex justify-content-end align-items-center'>
            {/* <ClientFilter
              setSelectedClient={setSelectedClient}
              setSelectedPortal={setSelectedPortal}
              selectedClient={selectedClient}
            />

            {selectedClient && (
              <PortalFilter
                setSelectedPortal={setSelectedPortal}
                selectedPortal={selectedPortal}
                selectedClient={selectedClient}
              />
            )} */}
             <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
              <Button
                className='m-1'
                variant='btn btn-primary'
                hidden={isHidden({ module: { key: 'Bonus', value: 'C' } })}
                onClick={() => navigate(AdminsRoutes.CreateBonus)}
              >
               <AddCircleOutlineRoundedIcon className='me-2' />
               <span>Create</span>
              </Button>
              <Button
                className='m-1'
                variant='btn btn-primary'
                hidden={isHidden({ module: { key: 'Bonus', value: 'U' } })}
                onClick={() => navigate(AdminsRoutes.BonusReorder)}
              >
              <Reorder className='me-2' />

                Reorder
              </Button>
              </motion.div>
             
              {/* <Button
                className='m-1'
                size='sm'
                style={{ minWidth: 'fit-content' }}
                hidden={isHidden({ module: { key: 'Bonus', value: 'Issue' } })}
                onClick={() => setShowGiveModal(true)}
              >
                Give Bonus
              </Button>
              <Button
                className='m-1'
                size='sm'
                style={{ minWidth: 'fit-content' }}
                hidden={isHidden({ module: { key: 'Bonus', value: 'Issue' } })}
                onClick={() => setShowFreeSpinModal(true)}
              >
                Issue Freespins
              </Button> */}
          </div>
        </Col>
          
      </Row>
    </div>
   
    <div className='FormsBg'>
    <Row className='mt-2'>
        <Col xs={12} sm={3}>
         
          <BForm.Select
            name='bonusType'
            size='sm'
            value={bonusTyp}
            onChange={(e) => setBonusTyp(e.target.value)}
          >
            <option value='' key=''>
            Bonus Type
            </option>
            {bonusType.map((item) => {
              return (
                item.value !== 'cashfreespins' &&
                  <option key={`bonusType ${item.value}`} value={item.value}>
                    {item.value === 'freespins' ? 'FREESPINS' : item?.label}
                  </option>
              )
            })}
          </BForm.Select>
        </Col>

        <Col xs={12} sm={3}>
         

          <BForm.Control
            type='search'
            value={search}
            placeholder='Search Promotion Title'
            size='sm'
            onChange={(event) => setSearch(event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ''))}
          />
        </Col>

        <Col xs={12} sm={3}>
         
          <BForm.Select
            name='isActive'
            size='sm'
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
          >
            <option value='' key=''>
              Status
            </option>
            <option value='true' key='active'>
              Active
            </option>
            <option value='false' key='in-active'>
              In-Active
            </option>
          </BForm.Select>
        </Col>
      </Row>
    </div>
      
<div className='TableBg mt-4'>
<BonusListing
        bonusList={bonusList}
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        tableHeaders={tableHeaders}
        show={show}
        setShow={setShow}
        handleYes={handleYes}
        active={active}
        handleShow={handleShow}
        navigate={navigate}
        name={name}
        loading={loading}
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
      />
</div>
     

      {/* {showGiveModal &&
        <GiveBonus
          showModal={showGiveModal}
          setShowModal={setShowGiveModal}
        />}

      {showFreeSpinModal &&
        <GiveFreeSpins
          showModal={showFreeSpinModal}
          setShowModal={setShowFreeSpinModal}
        />} */}
    </>
  )
}

export default BonusManagement
